import React from 'react';
import Input from '../../elements/Input';

function LocationSelectorSecondarySearch(props, ref) {
  const { onClear, onChange, onCloseMenu } = props;
  const [inputValue, setValue] = React.useState('');
  const focusRef = React.useRef(null);

  const handleInput = ($event) => {
    const inputValueSearch = $event.target.value;
    setValue(inputValueSearch);
    if (inputValueSearch === '') {
      onClear();
    }
    onChange(inputValueSearch);
  };

  const handleClear = () => {
    if (Boolean(inputValue)) {
      setValue('');
      onClear();
    }
  };
  const inputFocus = () => {
    focusRef.current?.focus();
  };
  React.useImperativeHandle(ref, () => ({
    clear: handleClear,
    focus: inputFocus,
    getValue: () => {
      return inputValue;
    }
  }));

  const handleKeyUp = (e) => {
    if (e.keyCode === 27) {
      onCloseMenu();
      props.focusSelectorInput();
    }
  };

  return (
    <>
      <Input
        name="search"
        rightIcons={Boolean(inputValue) ? ['close-material'] : ['searchV2']}
        rightAriaLabel={Boolean(inputValue) ? ['Clear'] : ['Search']}
        rightTabIndex={Boolean(inputValue) ? [0] : [-1]}
        onRightIconClick={handleClear}
        margin="2"
        marginTop="1"
        value={inputValue}
        focusReferences={focusRef}
        ariaLabelledBy={`label-search-${focusRef.current?.id}`}
        showLabelHidden={true}
        showLabel={true}
        autoComplete="off"
        {...props}
        onChange={handleInput}
        onKeyUp={handleKeyUp}
      />
    </>
  );
}

export default React.forwardRef(LocationSelectorSecondarySearch);
